import { Link } from "react-router-dom";
import { LogOut } from "lucide-react";
import { Chuckle, Drip, Shiver } from "./Characters";
import { useAuth } from "../lib/auth";

export const MiniHeader = () => {
  const { user, logout } = useAuth();
  return (
    <header className="bg-ink text-paper">
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-5 sm:px-8">
        <Link to="/" data-testid="mini-header-logo" className="flex items-center gap-2 rounded-full">
          <span className="flex -space-x-1.5"><Chuckle className="h-7 w-7" /><Drip className="h-7 w-7" /><Shiver className="h-7 w-7" /></span>
          <span className="font-head text-2xl leading-none">convey</span>
        </Link>
        {user && (
          <button type="button" data-testid="logout-button" onClick={logout} className="inline-flex items-center gap-2 rounded-full px-4 py-2 font-body font-semibold hover:bg-white/10">
            <LogOut size={18} /> Log out
          </button>
        )}
      </div>
    </header>
  );
};
